const levels = new Map();

levels.set(1, { spawnDelay: 1000, speed: 1.8, flowerShift: 'none' });
levels.set(2, { spawnDelay: 850, speed: 1.9, flowerShift: 'same' });
levels.set(3, { spawnDelay: 800, speed: 1.9, flowerShift: 'same' });
levels.set(4, { spawnDelay: 750, speed: 2, flowerShift: 'variable' });

levels.set(5, { spawnDelay: 700, speed: 2, flowerShift: 'variable' });
levels.set(6, { spawnDelay: 700, speed: 2.2, flowerShift: 'variable' });
levels.set(7, { spawnDelay: 700, speed: 2.3, flowerShift: 'variable' });
levels.set(8, { spawnDelay: 700, speed: 2.5, flowerShift: 'variable' });

levels.set(9, { spawnDelay: 600, speed: 2.5, flowerShift: 'variable' });
levels.set(10, { spawnDelay: 550, speed: 2.6, flowerShift: 'variable' });
levels.set(11, { spawnDelay: 500, speed: 2.7, flowerShift: 'variable' });
levels.set(12, { spawnDelay: 500, speed: 2.8, flowerShift: 'variable' });

export default levels;
